import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BannerSlide.css';

const defaultSlides = [
  {
    image: '/field1.jpeg',
    titlePrefix: 'Asesoría Técnica en',
    titleAccent: 'Plantaciones',
    sloganBadge: 'Con vainilla siempre sí!!',
    subtitle: 'Asesoría especializada para el manejo y producción de vainilla. Acompañamiento técnico en el establecimiento, manejo, nutrición, floración y desarrollo del cultivo.',
    buttonText: 'Conoce Nuestros Servicios',
    buttonLink: '/servicios',
    buttonIcon: 'leaf',
    secondaryButtonText: 'Agendar Consulta',
    secondaryButtonLink: '/contacto',
    secondaryButtonIcon: 'calendar',
  },
  {
    image: '/field2.jpeg',
    titlePrefix: 'Biotecnología y',
    titleAccent: 'Buenas Prácticas',
    sloganBadge: '100% Costarricense',
    subtitle: 'Protocolos de precisión, propagación in vitro y estándares de beneficiado gourmet para mercados internacionales.',
    buttonText: 'Nuestra Asesoría',
    buttonLink: '/servicios',
    buttonIcon: 'leaf',
    secondaryButtonText: 'Ver Productos',
    secondaryButtonLink: '/productos',
    secondaryButtonIcon: 'arrow',
  },
  {
    image: '/lab1.jpeg',
    titlePrefix: 'Diagnóstico temprano y ',
    titleAccent: 'prevención de riesgos en las plantaciones de vainilla',
    sloganBadge: 'Sol de Vainilla',
    subtitle: 'Conocimiento, acompañamiento y soluciones para el cultivo de vainilla. Un enfoque integral para su manejo',
    buttonText: 'Soluciones Sanitarias',
    buttonLink: '/servicios',
    buttonIcon: 'leaf',
    secondaryButtonText: 'Contactar Especialista',
    secondaryButtonLink: '/contacto',
    secondaryButtonIcon: 'calendar',
  },
];

function BannerSlide({ slides = defaultSlides, autoPlayInterval = 5500 }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused || slides.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, autoPlayInterval);

    return () => clearInterval(timer);
  }, [currentIndex, isPaused, slides.length, autoPlayInterval]);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (!slides || slides.length === 0) return null;

  return (
    <div
      className="banner-slider"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="banner-slides-track">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`banner-slide-item ${index === currentIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="banner-slide-overlay">
              <div className="banner-slide-content">
                {slide.sloganBadge && (
                  <span className="banner-slogan-badge">
                    ✦ {slide.sloganBadge} ✦
                  </span>
                )}

                <h1 className="banner-slide-heading">
                  <span className="heading-prefix">{slide.titlePrefix}</span>{' '}
                  <span className="heading-accent">{slide.titleAccent}</span>
                </h1>

                <div className="banner-gold-divider">
                  <span className="divider-line"></span>
                  <span className="divider-flower">❀</span>
                  <span className="divider-line"></span>
                </div>

                <p className="banner-slide-subtitle">{slide.subtitle}</p>

                <div className="banner-slide-buttons">
                  {slide.buttonText && slide.buttonLink && (
                    <Link to={slide.buttonLink} className="banner-primary-btn">
                      {slide.buttonIcon === 'leaf' && (
                        <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8z" />
                        </svg>
                      )}
                      <span>{slide.buttonText}</span>
                    </Link>
                  )}
                  {slide.secondaryButtonText && slide.secondaryButtonLink && (
                    <Link to={slide.secondaryButtonLink} className="banner-secondary-btn">
                      {slide.secondaryButtonIcon === 'calendar' && (
                        <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                          <line x1="16" x2="16" y1="2" y2="6" />
                          <line x1="8" x2="8" y1="2" y2="6" />
                          <line x1="3" x2="21" y1="10" y2="10" />
                        </svg>
                      )}
                      <span>{slide.secondaryButtonText}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Prev / Next Arrows */}
      <button
        type="button"
        className="banner-arrow banner-arrow-prev"
        onClick={prevSlide}
        aria-label="Slide anterior"
      >
        &#10094;
      </button>
      <button
        type="button"
        className="banner-arrow banner-arrow-next"
        onClick={nextSlide}
        aria-label="Siguiente slide"
      >
        &#10095;
      </button>

      {/* Dots Indicator */}
      <div className="banner-dots">
        {slides.map((_, index) => (
          <button
            type="button"
            key={index}
            className={`banner-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir al slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default BannerSlide;
